import { get } from 'lodash'
import gql from 'graphql-tag'
import client from '@stores/apollo'
import { TicketDetailsFragment } from '@api/fragments'
import { ITicketDetails, TicketStatus } from '@api/types'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  updateTicket: { ticket: ITicketDetails }
}

const mutateHandler = handleFetchResult<IPayload, ITicketDetails>({
  handler: (data) => data.updateTicket.ticket,
  name: 'Ticket',
})

export function update(ticket: ITicketDetails): Promise<ITicketDetails> {
  const input = {
    id: ticket.id,
    status: ticket.status,
    severity: ticket.severity,
    shortDescription: ticket.shortDescription,
    description: ticket.description,
    dueDate: ticket.dueDate,
    assignedToId: get(ticket, 'assignedTo.id', null),
    buildingId: get(ticket, 'building.id', null),
    floorPlanId: get(ticket, 'floor_plan.id', null),
  }

  return client.gql
    .mutate({
      mutation,
      variables: { input },
    })
    .then(mutateHandler)
}

interface BatchUpdateInput {
  assignedToId?: string
  status?: TicketStatus
}

export function batchUpdate(ids: string[], input: BatchUpdateInput) {
  const promises = ids.map((id) =>
    client.gql.mutate({
      mutation,
      variables: { input: { id, ...input } },
    })
  )
  return Promise.all(promises)
}

const mutation = gql`
  mutation updateTicket($input: UpdateTicketInput!) {
    updateTicket(input: $input) {
      ticket {
        ...TicketDetailsFragment
      }
    }
  }
  ${TicketDetailsFragment}
`
